import { v4 as uuidv4 } from 'uuid';
import getCarvanaUserId from './getCarvanaUserId';
import correlationId from './correlationId';
import getBrowserData from './getBrowserData';
import getDeviceData from './getDeviceData';
import type { EnvelopeOptions } from '../contracts';

const getEnvelope = async ({
  environment,
  project,
  track,
  eventName,
  correlationIdOverride,
  overrides,
  isImpersonating,
  useReferrerOverride,
}: EnvelopeOptions) => {
  const { browserCookieIdOverride, ...otherOverrides } = overrides || {};

  const carvanaUserId = await getCarvanaUserId();
  const browserData = await getBrowserData(
    typeof browserCookieIdOverride === 'string'
      ? browserCookieIdOverride
      : undefined,
    useReferrerOverride,
  );
  const deviceData = await getDeviceData();
  return {
    clickstream: {
      ...(carvanaUserId && {
        carvanaUser: { id: carvanaUserId },
      }),
      browser: browserData,
      device: deviceData,
    },
    event: {
      id: uuidv4(),
      name: eventName,
      timestamp: new Date(),
    },
    metadata: {
      correlationId: correlationIdOverride || correlationId,
      environment,
      project,
      track,
      ...otherOverrides,
    },
    impersonation: {
      isImpersonated: isImpersonating,
    },
  };
};

export default getEnvelope;
